import React from "react";
import {About,Header} from '../../Components'



const  Home = ()=> {
    return (
       <>
         <Header/>
         <About/>
      </>
    );
}

export default Home;
